import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
/* This component is used in
components/pages/comparison/charts/dailychart/index.jsx
components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
*/
const optionClicked = (props, day) => {
    props.chooseDay(day);
}
const generateDropdownItems = (props) => {
    return props.items.map((item, index) => {
        return (
            <DropdownItem key={index} >
                <div onClick={optionClicked.bind(this, props, item)}>
                    {item}
                </div>
            </DropdownItem>
        )
    });
}

const DaySelector = (props) => {
    let items = generateDropdownItems(props);
    return (
        <Dropdown className={props.className} header={props.day} toggleable>
            {items}
        </Dropdown>
    )
}
export default DaySelector





// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dayselector/index.jsx